/**
 * Created by andrey on 07.07.2025
 */

const SnailFeastWindowCupIcon = cc.Node.extend({
    ctor: function (mission, row) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.mission = mission;
        this.row = row;

        const place = this.place = row.place;

        const rewards = this.mission.getPrizeByPlace(row.place - 1);

        const bundleName = this.mission.getWindowBundleName();

        const cupJson = bundles[bundleName].jsons[`cup_${place}_json`];
        const cupFrame = bundles[bundleName].frames[`cup_${place}_png`];

        const icon = this.icon = cupJson ? new cleverapps.Spine(cupJson) : new cc.Sprite(cupFrame);

        this.setContentSize(icon.getContentSize());
        icon.setAlignment(this.width / 2, this.height / 2);
        this.addChild(icon);

        if (icon.setAnimation) {
            icon.setAnimation(0, "animation", true);
        }

        const tooltipOptions = this.tooltipOptions = {
            rewards,
            location: place < 5 ? cleverapps.UI.Tooltip.LOCATION_BELOW : cleverapps.UI.Tooltip.LOCATION_ABOVE
        };

        cleverapps.tooltipManager.create(this, tooltipOptions);

        this.setScale(0);
    },

    show: function (silent) {
        this.stopAllActions();

        if (silent) {
            this.setScale(1);
            return;
        }

        this.runAction(new cc.ScaleTo(0.2, 1).easing(cc.easeOutIn(1.5)).setFinalize(() => {
            this.setScale(1);
        }));
    },

    remove: function (silent) {
        this.stopAllActions();
        if (silent) {
            this.removeFromParent();
            return;
        }

        this.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 0).easing(cc.easeOutIn(1.5)),
            new cc.RemoveSelf()
        ));
    },

    win: function () {
        if (!this.icon.setAnimation) {
            this.remove();
            return;
        }

        this.icon.setAnimation(0, "open", false);
        this.icon.setCompleteListenerOnce(() => {
            this.removeFromParent();
        });
    },

    showTooltip: function (delay = 0) {
        this.runAction(new cc.Sequence(
            new cc.DelayTime(delay),
            new cc.CallFunc(() => {
                cleverapps.tooltipManager.onClick(this, this.tooltipOptions);
            })
        ));
    }
});